module.exports = __webpack_public_path__ + "media/spa/icon_area-bc35cdba.svg";